import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCaretLeftLarge = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 12.0355L6 8.03546L10 4.03546", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCaretLeftLarge);
const Memo = memo(ForwardRef);
export default Memo;
